import { Empty } from './empty'

export type { EmptyProps } from './empty'

export default Empty
